<script>
import Vue from 'vue'
import { MODAL, RELOAD } from '@constants/Text'
import { GlobalBus } from '@services/bus'
import rules from '@constants/Rules'
import { apiCrmTranscricoes } from '@modules/crm/api/apiCrmTranscricoes'

const buildDefaultItem = () => ({
  id: null,
  id_cliente: null,
})

export default {
  name: 'TranscriptClientModal',
  data() {
    return {
      busModal: new Vue(),
      rules,
      item: buildDefaultItem(),
      clientOptions: [],
      loadingClients: false,
      loading: false,
    }
  },
  created() {
    GlobalBus.$on(MODAL.TRANSCRIPT_CLIENT, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.TRANSCRIPT_CLIENT, this.open)
  },
  methods: {
    clear() {
      this.item = buildDefaultItem()
      this.loading = false
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
    open({ id = null, id_cliente = null } = {}) {
      this.clear()
      this.item = { id: id || null, id_cliente: id_cliente || null }
      this.loadClientes()
      this.busModal.$emit('dialog', true)
    },
    // Carrega a lista de clientes do escritório para o autocomplete. Mesmo shape
    // usado na view de transcrições (sessão do app x token da extensão).
    async loadClientes() {
      if (this.loadingClients) return
      this.loadingClients = true
      try {
        const r = await apiCrmTranscricoes.listarClientes()
        if (r && r.status === 200) {
          const value = r.value || {}
          const clients = Array.isArray(value) ? value : value.clients || []
          this.clientOptions = clients
            .map((c) => ({
              value: c.id || c.id_cliente,
              text:
                c.nome_cliente ||
                c.nome ||
                c.email ||
                'Cliente ' + (c.id || c.id_cliente),
            }))
            .filter((o) => o.value)
            .sort((a, b) => String(a.text).localeCompare(String(b.text)))
        } else {
          this.$showSnack(r)
        }
      } finally {
        this.loadingClients = false
      }
    },
    async save() {
      if (this.loading) return
      if (this.$refs.form && !this.$refs.form.validate()) return
      if (!this.item.id) return

      this.loading = true
      try {
        const r = await apiCrmTranscricoes.atualizar({
          id: this.item.id,
          id_cliente: this.item.id_cliente || null,
        })

        if (r && r.status === 200) {
          this.busModal.$emit('dialog', false)
          // Atualiza a lista de transcrições e o modal de detalhe aberto.
          GlobalBus.$emit(RELOAD.TRANSCRIPT)
        }

        this.$showSnack(r)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<template>
  <BaseModal
    centerScreen
    :bus="busModal"
    persistent
    centerAndDecreasesPadding
    maxWidth="500px"
    backgroundColor="white"
  >
    <div class="pb-6">
      <div class="modal-title-container">
        <span class="modal-title">Alterar cliente vinculado</span>
      </div>

      <div class="modal-content">
        <BaseValidationForm ref="form">
          <v-row>
            <v-col class="d-flex flex-column py-1" cols="12">
              <InputByType
                v-model="item.id_cliente"
                type="autocomplete"
                :options="clientOptions"
                :loading="loadingClients"
                placeholder="Selecione um cliente"
                outlined
                clearable
                class="align-icon-search"
                labelExternal="Cliente *"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
        </BaseValidationForm>
      </div>
    </div>

    <template v-slot:actions="{ close }">
      <div class="d-flex mt-4 az-gap-small">
        <BaseButton underlined @click="close"> Cancelar </BaseButton>
        <BaseButton primary :loading="loading" @click="save">
          Salvar
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>
